import { render, staticRenderFns } from "./Watt.vue?vue&type=template&id=034ca09a&scoped=true"
import script from "./Watt.vue?vue&type=script&lang=js"
export * from "./Watt.vue?vue&type=script&lang=js"
import style0 from "./Watt.vue?vue&type=style&index=0&id=034ca09a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034ca09a",
  null
  
)

export default component.exports